<template>
    <transition name="fade">
        <div v-if="data.message_type != 'warn'" :class="['message-modal-body-item', data.type ==  'admin' ? 'admin-part' : 'user-part']">
            <div class="message-modal-body-item-container">
                <div v-if="data.type ==  'admin'" class="message-modal-body-item-avatar">
                    <img src="../assets/avatar.png" alt="">
                </div>
                <div class="message-modal-body-item-content">
                    <div class="inner-html-wrapper">
                        <div v-if="data.message_type == 'text'" v-html="data.content"></div>
                        <div v-else>
                            <a target="blank" title="Click download file" :href="data.content.download_url">{{ data.content.name }}</a>
                        </div>
                    </div>
                </div>
                <div class="message-modal-body-item-meta" v-if="data.type ==  'user'">
                    <div class="timestamp">
                        <span title="Have read" v-if="data.is_read == '1'" class="message-modal-body-item-read is_read">
                            read
                            <svg viewBox="0 0 448.8 448.8">
                                <g>
                                    <polygon points="142.8,323.85 35.7,216.75 0,252.45 142.8,395.25 448.8,89.25 413.1,53.55   "/>
                                </g>
                            </svg>
                        </span>
                        <span v-else> unread</span>
                        {{ data.created_time | time }}
                    </div>
                </div>
            </div>
        </div>
        <div class="message-modal-body-item message-type-warn" v-else>
            <span class="message-type-warn-text">{{ data.content }}</span>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['data']
}
</script>


<style lang="scss" scoped>
.message-modal-body-item { padding-bottom: 10px; text-align: left; overflow: hidden;

    &.message-type-warn { color: #b8c8d2; font-size: 13px; text-align: center; margin-top: 10px; position: relative; margin-bottom: 15px;
        .message-type-warn-text { display: inline-block; background: #fff; z-index: 2; position: relative; padding: 0 3px; }
        &::before {content: ''; position: absolute; border-bottom: 1px solid #b8c8d2; width: 100%; top: 10px; left: 0 ; z-index: 1;}
    }
    
    &-container { position: relative; max-width: 75%;}
    &-avatar { position: absolute; left: 0; bottom: 10px; width: 30px; height: 30px; line-height: 30px; font-size: 15px; border-radius: 50%;
        vertical-align: middle;
        img, svg {width: 30px; height: 30px;}
        img { border-radius: 50%;}
    }
    &-content { padding: 17px 20px; border-radius: 6px; position: relative;
        .inner-html-wrapper {font-size: 14px; line-height: 1.4; margin: 0; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word;
            p { margin: 0 0 10px 0;}
            .ap-f-l-c { text-decoration: none; background: #215dd6; display: block; border-radius: 6px; padding: 5px 10px;}
        }
    }
    &-meta {clear: both; color: #b8c3ca; font-size: 13px; padding-top: 3px; width: 75%; float: right;
        .timestamp { white-space: nowrap; float: right;}
        .message-modal-body-item-read {
            svg {width: 12px; fill: #b8c3ca;}
            &.is_read { color: #acb92a;
                svg { fill: #acb92a; }
            }
        }
    }
    &.admin-part {
        .message-modal-body-item-container { float: left; padding-left: 45px;}
        .message-modal-body-item-content { color: #263238; background-color: #f4f7f9;
            a { color:#263238 !important; text-decoration: underline;}
        }
    }
    &.user-part {
        .message-modal-body-item-container { float: right; padding-right: 0;}
        .message-modal-body-item-content { color: #fff; background-color: #286efa;
            a { color:#fff; text-decoration: underline;}
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/MessageItem.vue